import {
  WEEKLY_WALKTHROUGH_EVENTS,
  type WeeklyWalkthrough,
} from "./weekly-walkthrough-types";

export const CURRENT_WEEKLY_WALKTHROUGHS = {
  "billing-analyst-access": {
    id: "billing-analyst-access",
    title: "Review Analyst Access",
    ctaLabel: "Review setting",
    targetRoute: "/?weeklyWalkthrough=billing-analyst-access",
    targetAction: "Open Settings -> Billing.",
    outcome: "See plan state, launch trial, and checkout or portal action.",
    prerequisites: "Signed-in user; checkout uses the live Stripe route.",
    targetTab: "settings",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.settingsTab,
    eventDetail: { tab: "billing" },
    dispatchDelayMs: 140,
    steps: [
      "Open Billing in Settings.",
      "Confirm Free or Analyst status and trial timing.",
      "Use Upgrade, Manage, or Stripe portal only for the intended account.",
    ],
  },
  "rate-cut-default-narrative": {
    id: "rate-cut-default-narrative",
    title: "Open Rate-Cut Narrative",
    ctaLabel: "Open demo",
    targetRoute:
      "/?weeklyWalkthrough=rate-cut-default-narrative&defaultNarrative=rate-cut-cycle",
    targetAction: "Open Consilium -> NarrativeFlow with rate-cut-cycle.",
    outcome: "Review real RiskFlow catalysts promoted into a narrative.",
    prerequisites: "Backend reachable; signed-in context improves continuity.",
    targetTab: "analysis",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.narrativeflowWorkspace,
    eventDetail: { defaultNarrative: "rate-cut-cycle" },
    dispatchDelayMs: 180,
    steps: [
      "Open NarrativeFlow from Consilium.",
      "Let the rate-cut-cycle default load from backend history.",
      "Review timeline, synthesis, and catalyst evidence before asking CAO.",
    ],
  },
  "riskflow-stock-context": {
    id: "riskflow-stock-context",
    title: "Review RiskFlow Stock Context",
    ctaLabel: "Open demo",
    targetRoute: "/?weeklyWalkthrough=riskflow-stock-context",
    targetAction: "Open RiskFlow and expand a ticker-linked headline.",
    outcome: "Use chart, POI, and invalidation context before CAO handoff.",
    prerequisites: "Live RiskFlow feed; stock chart endpoint improves cards.",
    targetTab: "riskflow",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.riskflowFocus,
    dispatchDelayMs: 160,
    steps: [
      "Open RiskFlow.",
      "Expand a headline with a ticker or market visual.",
      "Compare chart context, implied move, and Ask CAO before acting.",
    ],
  },
  "desktop-update-path": {
    id: "desktop-update-path",
    title: "Check Desktop Update",
    ctaLabel: "Review update",
    targetRoute: "/?weeklyWalkthrough=desktop-update-path",
    targetAction: "Open the footer version number, then Check Updates.",
    outcome: "Confirm the desktop update downloads before install handoff.",
    prerequisites:
      "Desktop app; web shows version info without installer APIs.",
    targetTab: "dashboard",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.versionInfo,
    dispatchDelayMs: 140,
    steps: [
      "Open the version number in the footer.",
      "Use Check Updates and wait for the download state.",
      "Install only after the update reports ready.",
    ],
  },
} as const satisfies Record<string, WeeklyWalkthrough>;
